/**
 * One menu item for the hand-rolled menus rendered inside AnchoredDropdown
 * and AdaptiveMenu: the row hover tint, 0.7 pressed opacity and a menuitem
 * role, on top of whatever layout style the host passes.
 */
import React from 'react';
import { Hoverable } from '@/components/shared/redesign/Hoverable';
import type { HoverableProps } from '@/components/shared/redesign/Hoverable';

export interface AnchoredDropdownItemProps extends Omit<HoverableProps, 'hover'> {
  /** The item is the current value: no tint on hover. */
  selected?: boolean;
}

export const AnchoredDropdownItem: React.FC<AnchoredDropdownItemProps> = ({ selected = false, accessibilityRole = 'menuitem', ...rest }) => (
  <Hoverable hover={selected ? 'none' : 'row'} accessibilityRole={accessibilityRole} {...rest} />
);
